export const isImage = (mimeType) => {
  return typeof mimeType === 'string' && mimeType.startsWith('image/');
};
